import type { CellContext } from '@tanstack/react-table';
import { ContentCell, type ContentCellProps } from '../../components/content-cell';
import type { DataGridColumnDef, DataGridColumnDefOptions } from '../../data-grid.type';

export function getColumnDefContent<T>(col: DataGridColumnDef<T>, options: DataGridColumnDefOptions) {
	return function ContentCellColumn(context: CellContext<T, unknown>) {
		const value = context.getValue() as ContentCellProps | null;
		const row = context.row.original;

		if (value == null || value === undefined || !options?.parse) return '';

		if (options?.parse) {
			const parsed = options.parse(value, row, options);

			return (
				<ContentCell
					primaryContent={parsed.primaryContent}
					primaryContentHover={parsed.primaryContentHover}
					secondaryContent={parsed.secondaryContent}
					moreContent={parsed.moreContent}
					moreContentHover={parsed.moreContentHover}
					moreContentLink={parsed.moreContentLink}
					icon={parsed.icon}
					iconOptions={parsed.iconOptions}
					endContent={parsed.endContent}
					dataTestId={parsed.dataTestId}
					dataReservationId={parsed.dataReservationId}
				/>
			);
		}
	};
}
